<template>
    <div class="w-full flex flex-col p-8 text-ternary">
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Thumbnail</div>
            <div class="w-3/4">
                <img class="h-48 object-contain" :src="getSrcFile(item.thumbnail)" alt="">
            </div>
        </div>
        <div v-if="item.type == 'partner'" class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Company Logo</div>
            <div class="w-3/4">
                <img class="h-48 object-contain" :src="getSrcFile(item.company_logo)" alt="">
            </div>
        </div>
        <div v-if="item.type == 'partner'" class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Organization Name</div>
            <div class="w-3/4">{{ item.organization_name }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Name</div>
            <div class="w-3/4">{{ item.name }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Designation</div>
            <div class="w-3/4">{{ item.designation }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Email</div>
            <div class="w-3/4">{{ item.email }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Phone</div>
            <div class="w-3/4">{{ item.phone }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Testimonial Type</div>
            <div class="w-3/4 capitalize">{{ item.testimonial_type }}</div>
        </div>
        <div v-if="item.testimonial_type == 'text'" class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Text Testimonial</div>
            <div class="w-3/4">{{ item.testimonial }}</div>
        </div>
        <div v-else class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Video Testimonial</div>
            <div class="w-3/4">
                <video v-if="item.upload_type == 'file'" width="560" height="315" controls>
                    <source :src="getTestimonialVideo" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
                <div v-else>
                    <div v-if="isYouTube">
                        <iframe width="560" height="315" :src="getTestimonialVideo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>
                    <div v-else>
                        <video width="560" height="315" controls>
                            <source :src="getTestimonialVideo" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Reveal Personal Information</div>
            <div class="w-3/4 capitalize">{{ getRevealStatus }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "view-testimonial",
    props: ["item"],
    computed: {
        getTestimonialVideo() {
            if (this.item.upload_type == 'file') {
                return process.env.VUE_APP_PUBLIC_URL + this.item.video_testimonial_file_url;
            } else {
                return this.item.video_testimonial_url;
            }
        },
        getRevealStatus() {
            if (this.item.dont_reveal === true) {
                return "No";
            } else {
                return "Yes";
            }
        },
        isYouTube() {
            return this.item.video_testimonial_url.includes("youtube.com");
        },
    },
    methods: {
        getSrcFile(url) {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
    },
}
</script>